import cx from 'classnames'

import { useThemeContext } from 'theme/themeProvider'

import { useCardHeightSync } from '../../hooks/useCardHeightSync'

import classes from './styles.module.scss'

type OptInInfoCardProps = {
  title: string
  text: string
  step: string
  registerHeight: (id: string, height: number) => void
  maxHeight: number
}

export const NewOptInInfoCard = ({ title, text, step, registerHeight, maxHeight }: OptInInfoCardProps) => {
  const { isDarkMode } = useThemeContext()
  const cardId = `card-${step}`

  const { containerRef, backgroundRef, rootRef, containerStyle, backgroundStyle, rootStyle } = useCardHeightSync({
    cardId,
    containerTopOffset: 10,
    registerHeight,
    maxHeight,
  })

  const stepConfig = {
    '1': {
      circleClass: classes.circleFirst,
      circleDarkClass: classes.circleFirstDarkMode,
      bgClass: classes.bgFirst,
    },
    '2': {
      circleClass: classes.circleSecond,
      circleDarkClass: classes.circleSecondDarkMode,
      bgClass: classes.bgSecond,
    },
    '3': {
      circleClass: classes.circleThird,
      circleDarkClass: classes.circleThirdDarkMode,
      bgClass: classes.bgThird,
    },
  }

  const config = stepConfig[step as keyof typeof stepConfig] || stepConfig['2']

  const circleClass = cx(
    classes.circle,
    config.circleClass,
    isDarkMode && config.circleDarkClass,
    isDarkMode && classes.circleDarkMode,
  )
  const backgroundClass = cx(classes.background, config.bgClass)

  return (
    <div ref={rootRef} className={classes.root} style={rootStyle}>
      <div ref={backgroundRef} className={backgroundClass} style={backgroundStyle} />
      <div className={circleClass}>
        <span className={classes.stepNumber}>{step}</span>
      </div>
      <div
        ref={containerRef}
        className={cx(classes.container, isDarkMode && classes.containerDarkMode)}
        style={containerStyle}
      >
        <div
          className={cx(classes.title, step === '1' && classes.titleFirst)}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <div className={classes.text}>
          <span dangerouslySetInnerHTML={{ __html: text }} />
        </div>
      </div>
    </div>
  )
}
